import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class PaymentExtraAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      ignores_debts: 1,
      training_id: '',
      staff_id: '',
      daily_currency: 'BRL',
      training_selected: 0,
      daily_value: 0,
      daily_paid: 0,
      bonus: '',
      certification_supplier: '',
      certification_supplier_id: '',
      daily_currency_list: [
        {value: "EUR", label: "Euro"},
        {value: "USD", label: "Dólar"},
        {value: "BRL", label: "Real"},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleSelectChangeTraining = this.handleSelectChangeTraining.bind(this);

    this.TrainingclearSelects = this.TrainingclearSelects.bind(this);
    this.loadTrainingData = this.loadTrainingData.bind(this);
    this.loadDailyValue = this.loadDailyValue.bind(this);
    this.add = this.add.bind(this);
    this.handleSelectChangeStaff = this.handleSelectChangeStaff.bind(this);
    this.loadStaffData = this.loadStaffData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeDailyValue (event, name) {
    var change = {};
    change[name] = event;

    this.setState(change);
    this.handleChangeDailyTotal(event, this.state.daily_paid);
  }

  handleChangeDaily (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(event.target.value, this.state.daily_paid);
  }
  handleChangeDailyPaid (name, event) {
    var change = {};
    change[name] = event.target.value;

    this.setState(change);
    this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
  }

  handleChangeDailyTotal (daily_value, daily_paid) {
    if (daily_paid !== null) {
        var daily_paid = daily_paid.toString().replace(',', '.');
  
      }
      if (daily_value !== null) {
        var daily_value = daily_value.toString().replace(',', '.');
  
      }
      var total = daily_paid * daily_value;

    this.setState({daily_total: total});
  }

  handleSelectChangeTraining(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
      this.setState(change, ()=> {
        this.TrainingclearSelects();
      });
    } else {
      change[name] = event.value;
      this.setState(change, ()=> {
        this.loadTrainingData(event);
      });
    }
  }

    handleSelectChangeStaff(name, event) {
      var change = {};
      if(event == null) {
        change[name] = null;
        this.setState(change, ()=> {
          this.setState({daily_value: ''});
        });
      } else {
        change[name] = event.value;
        this.setState(change, ()=> {
          this.loadStaffData(event);
        });
      }
    }


  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  TrainingclearSelects() {
    this.setState({training_selected: 0});
    this.setState({daily_value: ''});
    this.setState({daily_total: ''});
    this.setState({date_start: ''});
    this.setState({date_finish: ''});
    this.setState({training_code: ''});
    this.setState({daily_currency: ''});
    this.setState({certification_supplier_id: ''});
    this.loadData();
  }

  loadDailyValue(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/valor/diaria/local/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certification_supplier_id: responseJson.data.certification_supplier_id});
          self.setState({certification_supplier: responseJson.data.certification_supplier});
          self.setState({daily_currency: responseJson.data.daily_currency});
          self.handleChangeDailyValue(responseJson.data.daily_value, 'daily_value');
        }
        self.handleAlert('', '', 'closed');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  loadTrainingData(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/' + event.value;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({date_start: responseJson.data.date_start_str});
          self.setState({date_finish: responseJson.data.date_finish_str});
          self.setState({training_code: responseJson.data.code});
          self.setState({training_selected: 1});
          self.loadDailyValue(event);
        }
        self.handleAlert('', '', 'closed');
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

    loadStaffData(event) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/pagamento/valores/funcionario/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            Object.keys(responseJson.data).map(function(k) {
              if (responseJson.data[k].type === 'national' && responseJson.data[k].currency === self.state.daily_currency) {
                self.setState({daily_value: responseJson.data[k].value_str});
              }
              return true;
            });
          }
          self.handleAlert('', '', 'closed');
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        });
      });
    }


  loadData () {
    this.handleAlert('', '', 'open');
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamentos/codigos/lista/completo';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({trainings_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/colaboradores/ativos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staffs_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */ }); /* Lista de staffs */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      ignores_debts: this.state.ignores_debts,
      training_id: this.state.training_id,
      staff_id: this.state.staff_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      daily_value: this.state.daily_value,
      daily_paid: this.state.daily_paid,
      daily_total: this.state.daily_total,
      daily_currency: this.state.daily_currency,
      certification_supplier_id: this.state.certification_supplier_id,
      bonus: this.state.bonus,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/extra/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/pagamentos/abertos/extra';
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Adicionar pagamento</h3>
      <Link to="/pagamentos/abertos/extra" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Treinamento:</label>
              <Select
                className="form-field-name"
                name="training_id"
                value={this.state.training_id}
                searchable={true}
                placeholder={'Selecionar treinamento'}
                onChange={this.handleSelectChangeTraining.bind(this, 'training_id')}
                options={this.state.trainings_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Código do treinamento:</label>
              <input type="text" name="training_code" className="form-control" placeholder="" value={this.state.training_code} disabled="disabled" onChange={this.handleChange.bind(this, 'training_code')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Data inicial:</label>
              <InputMask value={this.state.date_start} disabled="disabled" maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data final:</label>
              <InputMask value={this.state.date_finish} disabled="disabled" maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Local:</label>
              <input value={this.state.certification_supplier} disabled="disabled" name="certification_supplier" className="form-control" onChange={this.handleChange.bind(this, 'certification_supplier')} placeholder="Local" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Colaborador:</label>
              <Select
                className="form-field-name"
                name="staff_id"
                value={this.state.staff_id}
                placeholder={'Selecionar Colaborador'}
                onChange={this.handleSelectChangeStaff.bind(this, 'staff_id')}
                options={this.state.staffs_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Diária valor:</label>
              <input value={this.state.daily_value} name="daily_value" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_value')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Diárias pagas:</label>
              <input value={this.state.daily_paid} name="daily_paid" className="form-control" onChange={this.handleChangeDailyPaid.bind(this, 'daily_paid')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Diária moeda:</label>
              <Select
                className="form-field-name"
                name="daily_currency"
                value={this.state.daily_currency}
                placeholder={'Selecionar moeda'}
                onChange={this.handleSelectChange.bind(this, 'daily_currency')}
                options={this.state.daily_currency_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Diária total:</label>
              <input value={this.state.daily_total} disabled="disabled" name="daily_total" className="form-control" onChange={this.handleChangeDaily.bind(this, 'daily_total')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar pagamento</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default PaymentExtraAdd;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/PaymentExtraAdd.js